export const APP_NAME = "ParkPay";
export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `/home`;
export const UNAUTHENTICATED_ENTRY = "/login";
export const API_VERSION = "/api/v1";
export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: "SIDE_NAV_LIGHT",
  locale: "en",
  navType: "SIDE",
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: "ltr",
  blankLayout: false,
};
